import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { UntypedFormControl, UntypedFormGroup } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { ActivatedRoute, Router } from "@angular/router";
import { ThemeService } from "../services/theme.service";
import { ForgotDialog } from "./forgot-dialog/forgot-dialog";
import { ToastrService } from "../components/_toastr/toastr.service";
import { ToolsService } from "../services/tools.service";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  standalone: false,
})
export class LoginComponent implements OnInit {
  public loginForm = new UntypedFormGroup({
    user: new UntypedFormControl(""),
    password: new UntypedFormControl(""),
    remember: new UntypedFormControl(false),
  });
  public bConnect = false;
  public hide = true;

  public theme = localStorage.getItem("Equora_Selected_Theme");

  constructor(
    public _dialog: MatDialog,
    public _theme: ThemeService,
    private _http: HttpClient,
    private _router: Router,
    private _route: ActivatedRoute,
    private _toastr: ToastrService,
    private _tools: ToolsService
  ) {}

  ngOnInit(): void {
    if (localStorage.getItem("Equora_Login") != null) {
      this.loginForm.get("user").setValue(localStorage.getItem("Equora_Login"));
    }

    if (localStorage.getItem("Equora_Password") != null) {
      this.loginForm
        .get("password")
        .setValue(localStorage.getItem("Equora_Password"));
    }

    if (localStorage.getItem("Equora_Remember") == "O") {
      this.loginForm.get("remember").setValue(true);
    }

    if (
      localStorage.getItem("Equora_Remember") == "O" &&
      localStorage.getItem("Equora_Password") != null
    ) {
      this.connect(this.loginForm);
    }
  }

  connect(log: UntypedFormGroup): void {
    if (log.status === "VALID") {
      this.bConnect = true;

      const params = {
        User: encodeURIComponent(log.value.user),
        Password: encodeURIComponent(log.value.password),
      };
      const header = new HttpHeaders({ "Content-Type": "application/json" });
      const httpOptions = { headers: header, params: params };
      this._http.get<any>("/api/login/connect", httpOptions).subscribe(
        (result) => {
          if (result.isOk) {
            if (result.obj.login_Base == "" || result.obj.login_Base == null) {
              this._toastr.show({
                title: "Erreur",
                message: "Base de données non trouvée",
                type: "error",
              });
              return;
            }

            sessionStorage.setItem("Equora_User", JSON.stringify(result.obj));

            localStorage.setItem("Equora_Login", log.value.user);
            if (log.value.remember) {
              localStorage.setItem("Equora_Remember", "O");
              localStorage.setItem("Equora_Password", log.value.password);
            }

            this._toastr.show({
              title: "Bienvenue",
              message: result.obj.login_Nom + " " + result.obj.login_Prenom,
              type: "welcome",
            });

            this._router.navigateByUrl(result.obj.login_Base);
          } else {
            this._toastr.show({
              title: "Erreur",
              message: result.message,
              type: "error",
            });
            this.bConnect = false;
          }
        },
        (error) => {
          this._tools.showHttpError(error);
          this.bConnect = false;
        }
      );
    }
  }

  hasError(form: UntypedFormGroup, controlName: string, errorName: string) {
    return form.controls[controlName].hasError(errorName);
  }

  openForgotDialog(): void {
    this._dialog.open(ForgotDialog, {
      width: "500px",
    });
  }
}
